import { GatherContentDocumentOption, GuidesAndTipsDocument, PostBase } from '../types';

/**
 * Guides
 */

export const sortGuidesPostCategoriesByLabel = (categories?: GatherContentDocumentOption[] | null) => {
  if (!categories) return [];
  const sortOrder = ['Caregiving 101', 'Care Support', 'Finance', 'Health', 'Housing', 'Legal', 'Quick Tips', 'End of Care'];
  return categories.sort((a, b) => {
    return sortOrder.indexOf(a.label) - sortOrder.indexOf(b.label);
  });
};

export const sortPostCategoriesByLabel = (categories?: string[]): string[] => {
  if (!categories) return [];
  const sortOrder = ['Caregiving 101', 'Care Support', 'Finance', 'Health', 'Housing', 'Legal', 'Quick Tips', 'End of Care'];
  return categories.sort((a, b) => {
    return sortOrder.indexOf(a) - sortOrder.indexOf(b);
  });
};

export const getGuiedsAndTipsDocumentPath = (item: GuidesAndTipsDocument) => {
  const slug = item.slug.replace(/[^a-zA-Z0-9-]/g, '');
  return `/guides-and-tips/${slug}`;
};

export const sortPostCategories = (categories: string[]) => {
  if (!categories) return [];
  const sortOrder = ['Caregiving 101', 'Care Support', 'Finance', 'Health', 'Housing', 'Legal', 'Quick Tips', 'End of Care'];
  return categories.sort((a, b) => {
    return sortOrder.indexOf(a) - sortOrder.indexOf(b);
  });
};

export const guidesAndTipsDocumentToPost = (post: GuidesAndTipsDocument): PostBase => {
  const { headerImage, slug } = post;
  const { authorName, headerTitle: title, categoryPill, privatePreview } = post.itemContent.content;
  const createdAt = post.fields?.createdAt ? new Date(post.fields?.createdAt) : new Date();
  const updatedAt = post.fields?.updatedAt ? new Date(post.fields?.updatedAt) : new Date();
  const categories = categoryPill ? sortPostCategories(categoryPill.map(itm => itm.label)) : [];
  const url = getGuiedsAndTipsDocumentPath(post);
  const isPrivate = privatePreview && privatePreview.length > 0 ? true : false;
  return {
    title,
    slug,
    url,
    headerImage,
    createdAt,
    updatedAt,
    categories,
    authorName,
    isPrivate,
  };
};
